import { EventEmitter } from 'events';
import { Parse } from '../runtime';

export class ErrorService extends EventEmitter {
    constructor() {
        super();
    }

    public handleParseErrors(error: Parse.Error) {
        console.warn('Parse Error!');
        console.warn(error);
        switch (error.code) {
            case 100:
                this.emit('exception', 'The server is currently unreachable. This might be caused by missing internet connectivity or server maintenance.');
                break;
            case 209:
                Parse.User.logOut().catch(() => undefined);
                this.emit('exception', 'The login-session is invalid. Please log in again.', true);
                break;
            default:
                // A failed application request does not invalidate the session.
                // Only Parse's explicit invalid-session response may log out.
                break;
        }
    }

    public handleConnectionError(error) {
        console.warn('Connection Error');
        console.warn(error);
        this.emit('exception', 'The server is currently unreachable. This might be caused by missing internet connectivity or server maintenance.');
    }
}
